import _pt from 'prop-types';
import 'react';
import TextInput from '@ebsco-ui/text-input';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import { jsxs, jsx } from 'react/jsx-runtime';

var baseClassName = "eb-date-range";
var DateRange = function DateRange(props) {
  var minDate = props.minDate,
      maxDate = props.maxDate,
      onChange = props.onChange,
      uniqueName = props.uniqueName,
      _props$i18n = props.i18n,
      minDateLabel = _props$i18n.minDateLabel,
      maxDateLabel = _props$i18n.maxDateLabel,
      isSharedError = props.isSharedError,
      placeholder = props.placeholder,
      className = props.className;
  var getBlocksWith = createBemBlockBuilder([baseClassName, className]);
  var inputBlockClassName = getBlocksWith("-input");

  var handleMinDateChange = function handleMinDateChange(_ref) {
    var newMinDate = _ref.target.value;
    onChange(newMinDate, maxDate.value);
  };

  var handleMaxDateChange = function handleMaxDateChange(_ref2) {
    var newMaxDate = _ref2.target.value;
    onChange(minDate.value, newMaxDate);
  };

  return /*#__PURE__*/jsxs("div", {
    className: cn(getBlocksWith(), // we need error state to be present, but without message, to avoid
    // message duplication for errors, related to both inputs.
    isSharedError && getBlocksWith("--shared-error")),
    "data-auto": "date-range",
    children: [/*#__PURE__*/jsx(TextInput, {
      id: "".concat(uniqueName, "MinDateInput"),
      label: minDateLabel,
      value: minDate.value,
      error: minDate.error,
      onChange: handleMinDateChange,
      placeholder: placeholder,
      "data-auto": "date-range-min-date",
      className: inputBlockClassName
    }), /*#__PURE__*/jsx(TextInput, {
      id: "".concat(uniqueName, "MaxDateInput"),
      label: maxDateLabel,
      value: maxDate.value,
      error: maxDate.error,
      onChange: handleMaxDateChange,
      placeholder: placeholder,
      "data-auto": "date-range-max-date",
      className: inputBlockClassName
    })]
  });
};
DateRange.propTypes = {
  className: _pt.string,
  i18n: _pt.shape({
    minDateLabel: _pt.string.isRequired,
    maxDateLabel: _pt.string.isRequired
  }).isRequired,
  isSharedError: _pt.bool.isRequired,
  minDate: _pt.shape({
    value: _pt.string.isRequired,
    error: _pt.string
  }).isRequired,
  maxDate: _pt.shape({
    value: _pt.string.isRequired,
    error: _pt.string
  }).isRequired,
  onChange: _pt.func.isRequired,
  placeholder: _pt.string,
  uniqueName: _pt.string.isRequired
};

export { DateRange, DateRange as default };
//# sourceMappingURL=date-range-esm.js.map
